export default "__VITE_ASSET__d2a99b0b__"